module.exports = __webpack_public_path__ + "img/TheMembers-1-pt.90a26491.png";